export class Filter {

  public id: string;
  public type: number;
  public data: any;

  public maxDefault: number;
  public maxPossible: number;
  public minDefault: number;
  public name: string;
  public lotteryId: string;
  public filterTypeId: any;
  public checked: boolean;
  order: number;
  customerOwner: boolean = false;
  filterGroupId: any;

}
export class FilterGroup {

  public id: string;
}

export class LotteryFilterParam {

  id:string;
  minLimit:number = 0;
  maxLimit:number = 0;
isChecked : boolean = false;
  customerOwner: boolean;
}
